/* eslint-disable @gorazdo/preact/forbid-render-arguments */
/* eslint-disable @gorazdo/preact/prefer-classname */
import { Component } from 'preact'
import axios from 'axios'

import Phrase from '../../libs/translationsUtils/phrase'
import { Author } from '../../services/unified'
import UserAvatar from '../User/UserAvatar'
import TrackingLink from '../link/tracking-link'
import { z } from 'zod'

export interface Props {
  maxResults: number
  period: number
  title: string
}

export interface LeaderboardProps {
  title: string
  leaderboard: LeaderboardUser[]
}

interface LeaderboardUser {
  author: Author
  likes: number
}

interface State {
  leaderboard: LeaderboardUser[]
}

export const widgetName = 'most_liked'

export const config = z.object({
  maxResults: z.number(),
  period: z.number(),
  title: z.string()
})

export const LeaderBoard = ({ title, leaderboard }: LeaderboardProps) => {
  if (!leaderboard || !leaderboard.length) return null
  return (
    <div class='box widget widget--likedusers qa-widget-most-liked'>
      <div class='box__content box__pad'>

        <h3 class='widget-title'>{title}</h3>

        <ul class='list list--userlikes qa-most-liked-post'>

          {leaderboard.map(({ author, likes }, i) =>
            <li key={i}>
              <div class='user flag flag--top'>

                <div class='flag__image '>
                  <UserAvatar user={author} showRank />
                </div>
                <div class='user_data flag__body'>

                  <TrackingLink
                    class='link username'
                    href={author.url}
                    track={{
                      type: 'Sidebar Widget Clicked',
                      widget: 'leaderboard'
                    }}
                    gaEvents={{
                      eventCategory: 'Homepage',
                      eventAction: 'Widget Clicked',
                      eventLabel: { Type: 'leaderboard' }
                    }}
                  >
                    {author.name}
                  </TrackingLink>

                  <p class='text--meta'>
                    <Phrase p='{n} like.single|{n} like.plural' count={{ n: likes }} />
                  </p>

                </div>

              </div>
            </li>)}
        </ul>
      </div>
    </div>
  )
}

class LeaderBoardDataFetcher extends Component<Props, State> {
  constructor () {
    super()
    this.state = { leaderboard: [] }
  }

  async componentDidMount () {
    const { data } = await axios.get('/widget/getLeaderBoard', {
      params: {
        period: this.props.period,
        maxResults: this.props.maxResults
      }
    })
    this.setState({ leaderboard: data.items })
  }

  render ({ title }: Props) {
    return <LeaderBoard title={title} leaderboard={this.state.leaderboard} />
  }
}

export default LeaderBoardDataFetcher
